const initializeCosmoBrands = (root = document) => {
  root.querySelectorAll('[data-cosmo-brands]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    if (section.dataset.motion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      section.classList.add('is-visible');
      observer.disconnect();
    }, { threshold: 0.12 });
    observer.observe(section);
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCosmoBrands(), { once: true });
else initializeCosmoBrands();
document.addEventListener('shopify:section:load', (event) => initializeCosmoBrands(event.target));
